export const InputTypeValue = {
  Button: 'button',
  Checkbox: 'checkbox',
  Color: 'color',
  Date: 'date',
  DatetimeLocal: 'datetime-local',
  Email: 'email',
  File: 'file',
  Hidden: 'hidden',
  Image: 'image',
  Month: 'month',
  Number: 'number',
  Password: 'password',
  Radio: 'radio',
  Range: 'range',
  Reset: 'reset',
  Search: 'search',
  Submit: 'submit',
  Tel: 'tel',
  Text: 'text',
  Time: 'time',
  Url: 'url',
  Week: 'week',
}

export const InputMode = {
  Decimal: 'decimal',
  Email: 'email',
  None: 'none',
  Numeric: 'numeric',
  Search: 'search',
  Tel: 'tel',
  Text: 'text',
  Url: 'url',
}

export const QA_NAME_INPUT_CONTEXT = 'inputField'

export const QA_NAME_INPUT_ERROR_DEFAULT = 'inputFieldError'
